let $nav;

function cacheDOM() {
  $nav = document.querySelector('.js-nav');
}

function initNav() {
  const $subnavItems = [...$nav.querySelectorAll('.js-nav__sub-item')];
  const $subnavContentItems = [...$nav.querySelectorAll('.js-nav__sub-item-content')];
  const $resetItems = [...$nav.querySelectorAll('.js-nav__reset-item')];
  let navOpen = false;

  function hideContent(excludeIndex = false, cleanUp = false) {
    $subnavItems.forEach(($item) => {
      $item.classList.remove('header-site__nav-item--is-subnav-active');
    });
    $subnavContentItems.forEach(($content, index) => {
      if (excludeIndex !== index) {
        $content.classList.remove('header-site__subnav--is-active');
        $content.setAttribute('aria-hidden', true);
      }
      // Wait for hide animations to complete and then remove primed state
      if (cleanUp && $content.classList.contains('header-site__subnav--is-primed')) {
        setTimeout(() => {
          $content.classList.remove('header-site__subnav--is-primed');
        }, 250);
      }
    });
    navOpen = false;
    if (!excludeIndex) {
      $nav.classList.remove('header-site--is-subnav-active');
    }
  }

  function showSubnav(index) {
    const $targetContent = $subnavContentItems[index];
    const $targetItem = $subnavItems[index];

    if ($targetContent) {
      $targetContent.classList.add('header-site__subnav--is-primed');
      setTimeout(() => {
        $targetContent.classList.add('header-site__subnav--is-active');
      }, 10);
      $targetContent.setAttribute('aria-hidden', false);
      $targetContent.focus();
      hideContent(index);
      $nav.classList.add('header-site--is-subnav-active');
      navOpen = true;
    }

    if ($targetItem) {
      $targetItem.classList.add('header-site__nav-item--is-subnav-active');
    }
  }

  $subnavItems.forEach(($navItem, index) => {
    $navItem.addEventListener('mouseenter', () => {
      showSubnav(index);
    });
  });

  function handleNavLeave() {
    $nav.addEventListener('mouseleave', () => {
      if (navOpen) hideContent(false, true);
    });
  }
  handleNavLeave();

  $resetItems.forEach(($resetItem) => {
    $resetItem.addEventListener('mouseenter', () => {
      hideContent(false, true);
    });
  });
}

export default function init() {
  cacheDOM();
  if ($nav) initNav();
}
